import React from 'react'
import { useTranslation } from 'react-i18next'
import HostEmptyState from '../../../../../public/emptystates/HostEmptystate.svg'

type Props = {
    name: string
    changeComponent: (componentName: string) => void
};

const EmptyHost = (props: Props) => {
  const { t } = useTranslation(['myDevices']);
  return (
    <div className="Services__FlexContent">
        <div className="Profile__FlexItem-NoPadding">
            <div className="ProfileForm__EmptyState">
                <div className="Services__ContentES">
                  <img src={HostEmptyState} alt='no devices' />
                </div>
                <p className="ProfileForm__EmptyStateTitle">
                    {t('host.emptyTitle')}
                </p>
                <p className="ProfileForm__EmptyStateSubtitle">
                    {t('host.addAHost')}
                </p>
                <button className="btn-primary" onClick={() => props.changeComponent("hostForm")}>
                    <i className="far fa-plus" />
                    <p className="Body2">
                        {t('addHost')}
                    </p>
                </button>
            </div>
        </div>
    </div>
  );
};

export default EmptyHost
